import React from 'react';
import './Brand.css';
import { google, slack, atlassian, dropbox, shopify} from './imports'

const Brand = () => {
  return (
    <div className='brand-container'>
      <div className='img-container'>
      <img src={google} alt="Google" />
      </div>
      <div className='img-container'>
      <img src={slack} alt="Slack" />
      </div>
      <div className='img-container'>
      <img src={atlassian} alt="Atlassian" />
      </div>
      <div className='img-container'>
      <img src={dropbox} alt="Dropbox" />
      </div>
      <div className='img-container'>
      <img src={shopify} alt="Shopify" />
      </div>
    </div>
  )
}

export default Brand
